module.exports = __webpack_public_path__ + "img/logout-confirmation.117da9f9.svg";